import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";
import PhoneIcon from "@material-ui/icons/Phone";
import ReplyIcon from "@material-ui/icons/Reply";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

// Render tipado de los botones de una plantilla HSM (Meta), reutilizable en el preview
// del modal y en el hilo de mensajes. Doc 0367 (H9). Diferencia por tipo con ícono,
// como los muestra WhatsApp: URL / teléfono / copiar código / respuesta rápida.
const useStyles = makeStyles(() => ({
  container: {
    marginTop: 6,
    borderTop: "1px solid rgba(0,0,0,0.12)",
    paddingTop: 2,
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    padding: "6px 0",
    fontSize: "0.83rem",
    fontWeight: 500,
    color: "#0a7cff",
    borderTop: "1px solid rgba(0,0,0,0.06)",
  },
}));

const iconForType = (type) => {
  switch (type) {
    case "URL":
      return LaunchIcon;
    case "PHONE_NUMBER":
      return PhoneIcon;
    case "COPY_CODE":
      return FileCopyOutlinedIcon;
    case "QUICK_REPLY":
    default:
      return ReplyIcon;
  }
};

const labelFor = (b) => {
  if (b.text) return b.text;
  switch (b.type) {
    case "URL":
      return "Abrir enlace";
    case "PHONE_NUMBER":
      return "Llamar";
    case "COPY_CODE":
      return "Copiar código";
    default:
      return "Responder";
  }
};

export default function WabaTemplateButtons({ buttons }) {
  const classes = useStyles();
  if (!buttons?.length) return null;

  return (
    <div className={classes.container}>
      {buttons.map((b, i) => {
        const Icon = iconForType(b.type);
        return (
          <div key={i} className={classes.button}>
            <Icon style={{ fontSize: 16 }} />
            <span>{labelFor(b)}</span>
          </div>
        );
      })}
    </div>
  );
}
